module.exports = __webpack_public_path__ + "img/business-deal-dark.1369d5bc.svg";